import { api } from '@/shared/services/api';
import { FeedItemAssignmentDto, SetFeedItemAssignmentRequest } from '@/shared/types/api';

/**
 * Assign to User (SC-423). Open to every signed-in user. The feed rows embed each item's
 * assignment, but the modal re-reads it with `get` when it opens, since the row may be stale,
 * and saves with `set` against that read's `updatedAt`.
 */
export const feedItemAssignmentApi = {
  /** The item's assignment, or null when it is not assigned (the API answers 204). */
  get: async (feedItemId: number): Promise<FeedItemAssignmentDto | null> => {
    const response = await api.get<FeedItemAssignmentDto | ''>(`/feeditems/${feedItemId}/assignment`);
    return response.status === 204 || !response.data ? null : response.data;
  },

  /** Saves the assignment; resolves to null when the request cleared it. */
  set: async (feedItemId: number, request: SetFeedItemAssignmentRequest): Promise<FeedItemAssignmentDto | null> => {
    const response = await api.put<FeedItemAssignmentDto | ''>(`/feeditems/${feedItemId}/assignment`, request);
    return response.status === 204 || !response.data ? null : response.data;
  },
};
